import "chart.js/auto";
import { Bar } from "react-chartjs-2";
import { colours } from "./colours";
import { Formatter } from "../format";

export const SpeakerTimeChart = ({ data = [] }) => {
  const options = {
    aspectRatio: 1.5,
    scales: {
      y: {
        stacked: true,
        ticks: {
          beginAtZero: true,
          callback: (value) => `${Formatter.Percentage(value)}`,
        },
      },
      x: {
        stacked: true,
        display: false,
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) =>
            `${context.dataset.label} ${Formatter.Percentage(
              context.parsed.y
            )}`,
        },
      },
      legend: {
        onClick: null,
        labels :{
          padding:10,
          boxWidth:15
        },
      },
    },
  };

  // Filter out invalid entries
  const validData = data.filter(entry =>
    entry &&
    typeof entry.value === 'number' &&
    !isNaN(entry.value) &&
    entry.value > 0
  );

  if (validData.length === 0) {
    return (
      <div className="text-center py-4 text-gray-500 text-sm">
        No speaker time data available
      </div>
    );
  }

  const totalTime = Math.ceil(validData.reduce((prev, curr) => curr.value + prev, 0));

  return (
    <Bar
    aria-label="This is a chart showing speaker and caller duration by percentage."
      data={{
        labels: ["Proportion speaking"],
        datasets: validData.map((entry) => ({
          label: entry.label || 'Unknown',
          data: [entry.value / totalTime],
          backgroundColor: colours[entry.channel] || '#6B7280',
        })),
      }}
      options={options}
    ></Bar>
  );
};
